export default {
      id: "phone-usage",
      viewBox: "0 0 25 25",
      url: "../../assets/" + "sprite.svg#phone-usage",
      toString: function () {
        return this.url;
      }
    }